module.exports = __webpack_public_path__ + "img/20190912105319360截图20190912094004623.cee8dfb1.jpg";